/** Source: ecod/api/src/Domain/Enums/View.cs **/
export enum EViewId {
  PO_ITEMS = 0, // po_it = 0
  PO = 10, // po = 10

  PO_ITEMS_LIST = 15, // po_it_list = 15
  // po_it_mob = 20 (not in frontend)
  // po_mob = 30 (not in frontend)
  PO_ITEM_MATERIALS = 40, // po_it_ship = 40
  SHIPMENT_ITEM_SERIALS = 50, // po_it_serial = 50
  PO_OVERVIEW = 60, // overview_po_it_detail = 60
  // overview_po_it_ship = 70 (not in frontend)
  // po_it_ship_details = 80 (not in frontend)
  // overview_po_it_detail_mob = 90 (not in frontend)

  SHIPMENT_OVERVIEW = 100, // shipment_overview = 100
  SHIPMENT_ITEMS = 110, // shipment_contents = 110

  SERIAL_NUMBERS = 120, // serialListView = 120

  DELIVERY_SCHEDULE_BOOKMARKED_ITEMS = 130, // ItemBookmarkPeriods = 130
  DELIVERY_SCHEDULE_ITEM_OVERVIEW = 140, // ItemOverview = 140

  NWH_INVENTORY = 145, // nwh_inventory = 145

  INTERNAL_PO = 150, // internal_po = 150

  ASP_INVENTORY = 155, // ASPInventory = 155

  INTERNAL_PO_ITEMS = 160, // internal_po_it = 160
  INTERNAL_ITEMS_LIST = 165, // internal_po_it_list = 165
  INTERNAL_PO_OVERVIEW = 170, // overview_internal_po_it_detail = 170

  SITE_MATERIALS = 175, // site_material_status = 175
  SITE_MILESTONES = 180, // site_milestone_status = 180

  BOM = 185, // site_bom_status = 185
  BOM_ITEMS = 190, // site_bom_material_status = 190
  // okr_dashboard = 195 (not in frontend)

  SERIAL_NUMBER_CHILDREN = 200, // child_serial_list_view = 200

  DELIVERY_SCHEDULE_BOOKMARK_ITEM = 205, // delivery_landing = 205
  // delivery_Item_list = 210 (not in frontend)
  INTERNAL_DELIVERY_SCHEDULE_BOOKMARK = 215, // internal_Delivery_Schedule_Landing = 215

  SHIPMENT = 220, // shipment = 220

  INTERNAL_SHIPMENT_OVERVIEW = 230, // internal_shipment_overview = 230
  INTERNAL_SHIPMENT_CONTENTS = 240, // internal_shipment_contents = 240

  INTERNAL_PO_IT_SERIAL = 250, // internal_po_it_serial = 250

  INTERNAL_SHIPMENT = 260, // internal_shipment = 260

  INTERNAL_DELIVERYSCHEDULE_BOOKMARKED_ITEMS = 270, // InternalDeliveryItemBookmarkPeriods = 270
  INTERNAL_DELIVERY_SCHEDULE_ITEM_OVERVIEW = 280, // InternalDeliveryItemOverview = 280

  SERIAL_NUMBERS_INTERNAL = 290, // Internal_serialListView = 290
  SERIAL_NUMBERS_CHILDREN_INTERNAL = 300, // child_Internal_serial_list_view = 300

  SITE_SCHEDULE = 310, // site_schedule = 310
  SHIP_TO_PARTY = 320, // internal_ship_to_party_view = 320 (not in frontend)

  //
  // Frontend-only entries (not added to backend yet)
  //
  DELIVERY_LIST = 500,
  DELIVERY_ITEM_LIST = 510,
  PURCHASE_ORDER_LIST = 520,
  PURCHASE_ORDER_LIST_VENDOR = 530
}
